import { Button, FormControl, FormHelperText, Input, InputLabel, Modal, Box, Snackbar, Alert } from '@mui/material';
import React, { useEffect, useState } from "react";
import { facade } from '../../helpers/analytic/AnalyticFacade';
import { MailChimpOpenEvent, MailChimpSubscribeEvent } from '../../helpers/analytic/event/MailChimpOpenEvent';
import jsonp from "jsonp";
import queryString from 'query-string';
import { getWalletAddress /*, updateQuest */ } from '../../commands/localStoreCommand';
import { sendEmailConfirmation } from '../../commands/user/sendEmailConfirmation';

type MailChimProps = {
    postUrl: string
}

const style = {
    display: "flex",
    flexDirection: "column",
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 260,
    minWidth: 260,
    bgcolor: '#ffffff;',
    //border: '1px solid #3e6ecd',
    borderRadius: 3,
    boxShadow: 24,
    p: 2,
    justifyContent: "center",
    alignItems: "center",
    outline: "none"
};

//@ts-ignore
const CustomForm = ({ status, message, open, handleOpen, handleClose, handleSubmit, setEmail, email, showJoinBtn }) => {

    return (
        <>
            {showJoinBtn && <Button variant="contained" className="mc-submit-btn" onClick={handleOpen}>JOIN EMAIL LIST</Button>}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className="mc-form">
                    <Box style={{ fontSize: 20, fontWeight: 700, whiteSpace: "nowrap" }}>Join Our Email List</Box>
                    <Box style={{ textAlign: "center", fontSize: 15, fontWeight: 400, color: "#555555", paddingTop: 5 }}>Hear first about updates</Box>
                    <Box style={{ textAlign: "center", fontSize: 15, fontWeight: 400, color: "#555555", paddingTop: 0, paddingBottom: 30 }}>and how to get on the whitelist</Box>


                    {status === '' && <FormControl style={{ maxWidth: 300, width: "100%" }} >

                        <InputLabel htmlFor="ed-email">Email address</InputLabel>
                        <Input value={email} style={{ marginBottom: 30 }} id="ed-email" aria-describedby="my-helper-text" onChange={(event) => setEmail(event.target.value)} />

                        <Button style={{ color: "white", fontWeight: 700 }} className="mc-submit-modal-btn" variant="contained" color="primary" type="submit" onClick={handleSubmit}>
                            Join Email List
                        </Button>

                        <Box onClick={handleClose} style={{ textAlign: "center", fontSize: 14, fontWeight: 400, color: "#555555", paddingTop: 10, paddingBottom: 0, textDecoration: "underline", cursor: "pointer" }}>No thanks</Box>
                    </FormControl>}

                    {status === 'sending' && <Box style={{ position: "relative", width: "100%", height: "100%", zIndex: 20, opacity: 0.9, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                        <Box style={{ color: "#222222", fontSize: 15, fontWeight: 400, }}>{message}</Box>
                        <Box style={{ color: "#555555", fontSize: 15, fontWeight: 400, }}>Please wait</Box>
                    </Box>}

                    {status === 'success' &&
                        <Box style={{ position: "relative", width: "100%", height: "100%", zIndex: 20, opacity: 0.9, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                            <Box style={{ color: "green", textAlign: "center", fontSize: 15, fontWeight: 400, }}>{message}</Box>
                            <Button style={{ marginTop: "30px", background: "#5865f2", color: "white", fontWeight: 700, fontSize: 12 }} onClick={handleClose} variant="contained" >close</Button>
                        </Box>
                    }

                    {status === 'error' &&
                        <Box style={{ position: "relative", width: "100%", height: "100%", zIndex: 20, opacity: 0.9, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                            <Box style={{ color: "red", fontWeight: 400, fontSize: 15 }}>{message}</Box>
                            <Button style={{ marginTop: "30px", background: "#5865f2", color: "white", fontWeight: 700, fontSize: 12 }} onClick={handleClose} variant="contained" >close</Button>
                        </Box>
                    }
                </Box>
            </Modal>
        </>
    );
};

type MailchimpFormContainerProps = {
    updateQuests: Function,
    open?: boolean,
    showJoinBtn: boolean,
    autoCloseOnSuccess?: boolean
}

const MailchimpFormContainer = (props: MailchimpFormContainerProps) => {
    const [status, setStatus] = useState<string>("");
    const [message, setMessage] = useState<string>("");
    const [open, setOpen] = React.useState(false);
    const [email, setEmail] = useState('');

    //
    useEffect(() => {
        if (props.open) {
            handleOpen();
        }
    }, [props.open]);


    const handleOpen = () => {
        facade.sendEvent(new MailChimpOpenEvent());
        setOpen(true);
    }

    const handleClose = () => {
        if (status !== 'sending') {
            setOpen(false);
            setStatus(""); //reset
            setEmail("");
            setMessage("");
        }
    };

    const handleSubmit = (e: any) => {
        facade.sendEvent(new MailChimpSubscribeEvent());
        e.preventDefault();

        email &&
            email.indexOf("@") > -1 &&
            subscribe({
                EMAIL: email
            });
    }

    const subscribe = (data: any) => {
        setStatus("sending");
        setMessage("Sending verification email...");

        let address = getWalletAddress();

        sendEmailConfirmation(email, address).then(res => {

            if (res.status >= 0) {
                setStatus("success");
                setMessage("A verification email has been sent. Please check your email.");

                if (props.autoCloseOnSuccess) {
                    handleClose();
                }
            } else {
                setStatus("error");
                setMessage("An error occurred");
            }
        })
    };

    return (
        <div>
            <CustomForm
                showJoinBtn={props.showJoinBtn}
                status={status}
                message={message}
                open={open}
                handleClose={handleClose}
                handleOpen={handleOpen}
                handleSubmit={handleSubmit}
                setEmail={setEmail}
                email={email}
            />
        </div>
    );
};

export default MailchimpFormContainer;